import { render, staticRenderFns } from "./CoursewareLearning.vue?vue&type=template&id=c1f0af18&scoped=true&"
import script from "./courseware-learning.js?vue&type=script&lang=js&"
export * from "./courseware-learning.js?vue&type=script&lang=js&"
import style0 from "./CoursewareLearning.vue?vue&type=style&index=0&id=c1f0af18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f0af18",
  null
  
)

export default component.exports